import * as React from 'react'

const ArrowRight2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-label='Arrow Right'
    fill='none'
    height='18'
    role='img'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Arrow Right</title>
    <path d='m9 18 6-6-6-6' />
  </svg>
)

export default ArrowRight2



// WEBPACK FOOTER //
// ./src/components/icons/ui/ArrowRight_2.tsx